import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { LoadingStates } from 'shared/constants/loadingStates';
import { PLANT_DESIGN_API_BASE_URL, PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';
import { clearPlantDesignForm } from 'plantItemNew/redux/slices/formSlice';

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const feesSlice = createSlice({
  name: 'plantDesignFees',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlantDesignFees.pending, (state, action) => {
        state.status = LoadingStates.Loading;
        state.error = null;
      })
      .addCase(getPlantDesignFees.rejected, (state, action) => {
        state.status = LoadingStates.Rejected;
        state.error = action.error.message;
      })
      .addCase(getPlantDesignFees.fulfilled, (state, action) => {
        state.status = LoadingStates.Succeeded;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(clearPlantDesignForm, () => {
        return initialState;
      });
  },
});

const apiUrl = `${PLANT_DESIGN_API_BASE_URL}/fees`;

export const getPlantDesignFees = createAsyncThunk('plantDesignFees/getFees', async (_, { getState }) => {
  const state = getState();

  const { applicationId, applicationNo, licenceType } = state.application;

  // TODO: Use the details from the actual application
  const payload = {
    applicationId,
    licenceType,
    applicationNo,
    applicantType: PlantDesignConstants.applicantType,
    durationRequested: PlantDesignConstants.duration,
    itemCount: PlantDesignConstants.itemCount,
    plantTransactionType: PlantDesignConstants.transactionType,
  };

  const response = await axios.post(apiUrl, payload, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  return response.data.response[0];
});

export const plantDesignFeesReducer = feesSlice.reducer;
